import { render, staticRenderFns } from "./PackCategoryList.vue?vue&type=template&id=1aca00cc&scoped=true"
import script from "./PackCategoryList.vue?vue&type=script&lang=ts"
export * from "./PackCategoryList.vue?vue&type=script&lang=ts"
import style0 from "./PackCategoryList.vue?vue&type=style&index=0&id=1aca00cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aca00cc",
  null
  
)

export default component.exports